import React, { useEffect, useState } from "react";
import useHttp from "../../../hook/use-http";
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitalstates_kratos';
import GaugeChart_Kratos from "./GaugeChart_Kratos";

export default function ThreeGaugeChart_Kratos({ gloablfilter }) {
  const [gauge_data, setgauge_data] = useState({})
  const [gauge_color, setGauge_color] = useState("")
  const { isLoading, error, sendReq: fetchData } = useHttp();

  const appyData = (data) => {
    (gloablfilter.VIN_NUM.length === 1) ? setGauge_color("#3578b0") : setGauge_color("#83A4CF")
    setgauge_data({ "dataNet_kWh": data[0].dataNet_kWh.value / data[0].distanceInKM.value, "dataCons_kWh": data[0].dataCons_kWh.value / data[0].distanceInKM.value, "dataRegen_kWh": data[0].dataRegen_kWh.value / data[0].distanceInKM.value })
  }

  useEffect(() => {
    fetchData({ url: API_URL_MAIN + "kratos_energy_analytics/three_gauge_chart", body: { filterdata: gloablfilter } }, appyData)
  }, [gloablfilter])

  return (
    <>
      <div className="row ml-0 energyChartboxNew_Kratos" style={{ backgroundColor: 'white' }}>
        <div className="row ml-0 energyTitleChart_Kratos pt-2 pb-2 pr-0 text-center">
          <div className="col-md-4 col-sm-4 col-lg-4">
            <b className=''>Net Consumption</b>
          </div>
          <div className="col-md-4 col-sm-4 col-lg-4 pr-0" style={{ position: 'relative' }}>
            <b style={{ position: 'absolute', top: '0', left: '0', paddingBottom: '5px' }}>=</b>
            <b className=''>Energy Consumption</b>
          </div>
          <div className="col-md-4 col-sm-4 col-lg-4 pr-0" style={{ position: 'relative' }}>
            <b style={{ position: 'absolute', top: '0', left: '0', paddingBottom: '5px' }}>-</b>
            <b className=''>Energy Regenerated</b>
          </div>
        </div>
        <div className="col-md-4 col-sm-12 col-lg-4">
          <GaugeChart_Kratos range_end={2} range_main={gauge_data.dataNet_kWh} title="Net Consumption" gauge_color={gauge_color} />
        </div>
        <div className="col-md-4 col-sm-12 col-lg-4">
          <GaugeChart_Kratos range_end={2} range_main={gauge_data.dataCons_kWh} title="Energy Consumption" gauge_color={gauge_color} />
        </div>
        <div className="col-md-4 col-sm-12 col-lg-4">
          <GaugeChart_Kratos range_end={1} range_main={gauge_data.dataRegen_kWh} title="Energy Regenerated" gauge_color={gauge_color} />
        </div>
      </div>
    </>
  )
}
